<template>
<div>
	<FormRow>
  		<input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/> 
  		<FormLabel for="inHonorOf">Dedicate your donation</FormLabel>
	</FormRow>
	<div  v-if="inHonorOf" class="honor-container">
		<FormRow inline>
			<FormCol field="dedication" :flex="1">
				 <FormSelect>
				<option value="In honor of">In honor of</option>
				<option value="In memory of">In memory of</option>
				</FormSelect>
			</FormCol>
			<FormCol field="dedicationMessage"  :flex="3"/>
		</FormRow>
		<FormRow inline>
			<div>
				<FormLabel for="dateType" class="control-label">Date Type</FormLabel>
				<FormSelect field="custom.dateType">
					<option value="Dedication">Dedication Date</option>
					<option value="Yarzheit">Yarzheit Date</option>
				</FormSelect>
			</div>
			<FormCol field="custom.dedicationDate">
				<FormInput type="text"/>
			</FormCol>
		</FormRow>
		<FormRow inline>
			<FormCol field="custom.shiurORTeacher">
				<FormInput type="text" width="half"/>
			</FormCol>
		</FormRow>
		<FormRow>
			<input type="checkbox" id="mentionTidbits" name="mentionTidbits" @click="setValue('custom.mentionTidbits', $event.target.checked)"/> 
			<FormLabel for="mentionTidbits">I'm interested in having my dedication be mentioned in Torah Tidbits.</FormLabel>
		</FormRow>
	</div>
</div>
</template>
<script setup lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form'
import {  ref, watch } from 'vue'

const inHonorOf = ref(false)
const dateType = 'dedicationDateFlag'
const { form, setValue } = usePaymentForm()

setValue('callback', process.env.NODE_ENV != 'production' ? 'https://ouisrael.oudev.org/wp-json/api/torah-tidbits/email-dedication' : 'https://ouisrael.org/wp-json/api/torah-tidbits/email-dedication')
</script>
<style scoped lang="scss">
input[type="checkbox"] {
	margin-right: 7px;
}
.honor-container {
	padding-top: 20px;
	border-top: 1px solid #ddd;
	margin-top: 20px;
}
.flex {
	display: flex;
	align-items: center;
}
.honor-type {
	max-width: 150px;
	min-width: 150px;
	margin-right: 7px;
}
.edit-recipient {
	color: $color-blue;
	font-size: 13px;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
}
.radio-part {
	flex: 1;
}
.date-field {
	flex: 3
}
.control-label {
	flex: 1;
    max-width: 150px;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
}
</style>